export class GetDataCatalogSemanticLayerSeedArtifactResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "url",
            "baseName": "url",
            "type": "string",
            "format": ""
        },
        {
            "name": "version",
            "baseName": "version",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "artifactSha256",
            "baseName": "artifactSha256",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetDataCatalogSemanticLayerSeedArtifactResponse.attributeTypeMap;
    }
    constructor() {
    }
}
